module.exports = __webpack_public_path__ + "static/media/pic13.3821b833.jpg";